import React from "react";

const TableFooter = ({
  selectedCount,
  totalCount,
  currentPage,
  totalPages,
  onPrevious,
  onNext,
  prevDisabled,
  nextDisabled,
  showSelection = true,
}) => {
  return (
    <div className="mt-12 flex relative items-center justify-center">

      <button
        type="button"
        onClick={onPrevious}
        disabled={prevDisabled}
        className="inline-flex absolute left-1 bottom-1 items-center rounded-full bg-[#923D8C] px-[18px] py-1 leading-[14px] text-xs text-white transition hover:bg-[#863F86] disabled:cursor-not-allowed disabled:opacity-50"
      >
        Previous
      </button>

      <p className="text-xs text-black">
        Page {currentPage}/{totalPages}
      </p>

      <button
        type="button"
        onClick={onNext}
        disabled={nextDisabled}
        className="inline-flex absolute right-1 bottom-1 items-center rounded-full bg-[#923D8C] px-[28.7px] py-1 leading-[14px] text-xs text-white transition hover:bg-[#863F86] disabled:cursor-not-allowed disabled:opacity-50"
      >
        Next
      </button>
    </div>
  );
};

export default TableFooter;
